import React from 'react';
// components
import Typography from 'components/Typography';
import DismissBanner from './DismissBanner';
// icons
import { ReactComponent as HourglassIcon } from 'icons/hourglass.svg';
// styles
import classnames from 'classnames/bind';
import styles from './DismissBanner.module.scss';

const cx = classnames.bind(styles);

const NoDataBanner = ({ onStateChange, className }) => {
  const bannerRenderer = () => (
    <>
      <div className={cx('hourglass-wrapper')}>
        <HourglassIcon />
      </div>
      <Typography
        className={cx('text', 'mgl-20')}
      >{`Waiting for data! Once you have class data, you'll see it here.`}</Typography>
    </>
  );

  return <DismissBanner onStateChange={onStateChange} className={className} contentRenderer={bannerRenderer} />;
};

export default NoDataBanner;
